document.addEventListener('click', (e) => {
  const btn = e.target.closest('.card__qty-btn');
  if (!btn) return;

  const wrap = btn.closest('.card__qty');
  const input = wrap?.querySelector('.card__qty-input');
  if (!input) return;

  const min = parseInt(input.getAttribute('min') || '1', 10);
  const current = parseInt(input.value || String(min), 10);

  if (btn.dataset.qty === 'plus') input.value = current + 1;
  if (btn.dataset.qty === 'minus') input.value = Math.max(min, current - 1);
});
